import { InboxOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import defaultPreview from "../../assets/img/Excel-logo.png";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import axiosMultiPartDataInstance from "../../variables/api/axiosMultiPartDatainstance";

const MigrationDeclarationSinistre = () => {
    const [loading, setLoading] = useState(false);
    const [loadingPool, setLoadingPool] = useState(false);
    const [fichier, setFichier] = useState("");

    const handlePreview = (file) => {
        console.log("file: ", file);
        this.setState({
            previewImage: defaultPreview,
            previewVisible: true,
        });
    };

    const navigate = useNavigate();

    const onSubmit = (e) => {
        setLoading(true);
        e.preventDefault();
        // console.log("submit");
        const formData = new FormData();
        formData.append("fichier", fichier.originFileObj);
        axiosMultiPartDataInstance.post('/api/migration/declaration-sinistre', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
        setLoading(false);

    };

    const onSubmitPool = (e) => {
        setLoadingPool(true);
        e.preventDefault();
        // console.log("submit");
        const formData = new FormData();
        formData.append("fichier", fichier.originFileObj);
        axiosMultiPartDataInstance.post('/api/migration/pool-declaration-sinistre', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            console.log(res);
            setLoadingPool(false);
        }).catch(err => {
            console.log(err);
            setLoadingPool(false);
        });

    };

    const onSubmitPoolRefresh = (e) => {
        setLoadingPool(true);
        e.preventDefault();
        // console.log("submit");
        const formData = new FormData();
        formData.append("fichier", fichier.originFileObj);
        axiosMultiPartDataInstance.post('/api/migration/refresh-type-sinistre', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            console.log(res);
            setLoadingPool(false);
        }).catch(err => {
            console.log(err);
            setLoadingPool(false);
        });

    };



    const uploadSubmit = (e) => {
        e.fileList.forEach((file) => {
            console.log("File: ", file);
            setFichier(file);
        });
    };

    const removeFile = (e) => {
        console.log("removeFile: ", e);
    };


    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <form onSubmit={onSubmit}>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">
                                                <div class="card-header bg-primary text-white">
                                                    <div class="card-text">
                                                        <h4 className="text-white">
                                                            Charger les bordereaux de déclarations de sinistres
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div class="card-body">
                                                    <div class="row">
                                                        <div className="col-12">
                                                            <br />
                                                            {/* <!-- Dragger Section for File Upload --> */}
                                                            <div
                                                                class="p-3 border"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                <div class="custom-file">
                                                                    <Dragger
                                                                        onChange={(e) => uploadSubmit(e)}
                                                                        beforeUpload={() => false}
                                                                        onRemove={(e) => removeFile(e)}
                                                                        accept={".xlsx,.csv, .xls"}
                                                                        onPreview={handlePreview}
                                                                        maxCount={1}
                                                                    >
                                                                        <p className="ant-upload-drag-icon">
                                                                            <InboxOutlined />
                                                                        </p>
                                                                        <p className="ant-upload-text">
                                                                            Cliquez ou faites glisser le fichier dans
                                                                            cette zone pour le téléverser
                                                                        </p>
                                                                    </Dragger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="card-footer d-flex justify-content-center">
                                                    <button
                                                        class="btn btn-primary"
                                                        disabled={loading}
                                                        onClick={(e) => onSubmit(e)}
                                                    >
                                                        {loading && (
                                                            <span
                                                                class="spinner-grow me-1"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                        )}
                                                        {loading ? `Enregistrement...` : `Enregistrer`}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br />
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <form onSubmit={onSubmitPool}>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">
                                                <div class="card-header bg-primary text-white">
                                                    <div class="card-text">
                                                        <h4 className="text-white">
                                                            Charger les bordereaux de déclarations de sinistres du Pool TPVM-VT GIE
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div class="card-body">
                                                    <div class="row">
                                                        <div className="col-12">
                                                            <br />
                                                            {/* <!-- Dragger Section for File Upload --> */}
                                                            <div
                                                                class="p-3 border"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                <div class="custom-file">
                                                                    <Dragger
                                                                        onChange={(e) => uploadSubmit(e)}
                                                                        beforeUpload={() => false}
                                                                        onRemove={(e) => removeFile(e)}
                                                                        accept={".xlsx,.csv, .xls"}
                                                                        onPreview={handlePreview}
                                                                        maxCount={1}
                                                                    >
                                                                        <p className="ant-upload-drag-icon">
                                                                            <InboxOutlined />
                                                                        </p>
                                                                        <p className="ant-upload-text">
                                                                            Cliquez ou faites glisser le fichier dans
                                                                            cette zone pour le téléverser
                                                                        </p>
                                                                    </Dragger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="card-footer d-flex justify-content-center">
                                                    <button
                                                        class="btn btn-primary"
                                                        disabled={loadingPool}
                                                        onClick={(e) => onSubmitPool(e)}
                                                    >
                                                        {loadingPool && (
                                                            <span
                                                                class="spinner-grow me-1"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                        )}
                                                        {loadingPool ? `Enregistrement...` : `Enregistrer`}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br />
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <form onSubmit={onSubmitPoolRefresh}>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">
                                                <div class="card-header bg-primary text-white">
                                                    <div class="card-text">
                                                        <h4 className="text-white">
                                                            Charger les bordereaux de déclarations de sinistres du Pool TPVM-VT GIE - Refresh
                                                        </h4>
                                                    </div>
                                                </div>

                                                <div class="card-body">
                                                    <div class="row">
                                                        <div className="col-12">
                                                            <br />
                                                            {/* <!-- Dragger Section for File Upload --> */}
                                                            <div
                                                                class="p-3 border"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                <div class="custom-file">
                                                                    <Dragger
                                                                        onChange={(e) => uploadSubmit(e)}
                                                                        beforeUpload={() => false}
                                                                        onRemove={(e) => removeFile(e)}
                                                                        accept={".xlsx,.csv, .xls"}
                                                                        onPreview={handlePreview}
                                                                        maxCount={1}
                                                                    >
                                                                        <p className="ant-upload-drag-icon">
                                                                            <InboxOutlined />
                                                                        </p>
                                                                        <p className="ant-upload-text">
                                                                            Cliquez ou faites glisser le fichier dans
                                                                            cette zone pour le téléverser
                                                                        </p>
                                                                    </Dragger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="card-footer d-flex justify-content-center">
                                                    <button
                                                        class="btn btn-primary"
                                                        disabled={loadingPool}
                                                        onClick={(e) => onSubmitPoolRefresh(e)}
                                                    >
                                                        {loadingPool && (
                                                            <span
                                                                class="spinner-grow me-1"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                        )}
                                                        {loadingPool ? `Rafraichissement...` : `Rafraichir`}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>

            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
};

export default MigrationDeclarationSinistre;